// extracted by mini-css-extract-plugin
module.exports = {"Labeled":"Labeled_Labeled__1msLh"};